import { getPasscodeErrorType, errorTypes } from 'config/passcode';
import * as clientErrTypes from 'config/clientErrorTypes';
import { generateApiErrObj } from 'client/hooks/useClientErrorHandler';
import { getPasscodeVerify } from 'api/client';
import Cookies from 'js-cookie';

/**
 * 驗證通行碼的功能
 * @param {Object} state - Redux store 狀態
 * @param {Object} state.promo - 活動相關資訊
 * @param {string} state.promo.uuid - 活動 UUID
 * @param {Object} state.promoState - 活動狀態
 * @param {boolean} state.promoState.enablePasscodeVerify - 是否啟用通行碼驗證
 * @param {string} state.promoState.passcode - 通行碼
 * @param {Function} mergeAndDispatchState - 更新 Redux store 狀態的函數
 * @param {string} recaptchaToken - reCAPTCHA token
 * @returns {Promise<boolean|string|Object>}
 * - 如果未啟用通行碼驗證，返回 false
 * - 如果驗證成功，返回 false
 * - 如果驗證失敗，返回錯誤類型
 * - 如果發生其他錯誤，拋出 API 錯誤物件
 */
async function checkPasscodeVerify(state, mergeAndDispatchState, recaptchaToken) {
    const {
        promo: { uuid: promoUUID },
        promoState: { enablePasscodeVerify, passcode }
    } = state;
    if (!enablePasscodeVerify) {
        return false;
    }

    if (passcode) {
        const recaptchaTokenByCookie = Cookies.get('reTkn');
        const resp = await getPasscodeVerify({
            promoUUID,
            passcode,
            recaptchaToken: recaptchaToken || recaptchaTokenByCookie
        });
        const {
            httpStatus,
            payload: { data }
        } = resp;
        if (httpStatus === 200) {
            mergeAndDispatchState({
                hasUsablePasscode: Boolean(data?.remainingCounts),
                passcode: data?.remainingCounts ? passcode : '',
                passcodeRemainingCount: data?.remainingCounts
            });
            return false;
        } else if (
            [
                errorTypes.DUPLICATE,
                errorTypes.USAGE_LIMIT_EXCEEDED,
                errorTypes.RECAPTCHA_TOK_AUTH_FAILED,
                errorTypes.ERROR
            ].includes(getPasscodeErrorType(resp))
        ) {
            return getPasscodeErrorType(resp);
        } else {
            throw generateApiErrObj(resp, clientErrTypes.VERIFY_PASSCODE);
        }
    } else {
        return false;
    }
}

export default checkPasscodeVerify;
